module.exports = __webpack_public_path__ + "static/media/markerStop.728068b7.svg";